import { DictionaryGeneratorContainer } from 'modules/Taps/redux/ndfl3Saga/DictionaryGeneratorContainer';
import {
  getActionTypesForLawyers,
  getObjectNameCodes,
  getPropertyRightsNDFL3,
  getTaxDeductionOwnerCodes,
} from 'modules/Taps/services/API/dictionaries';
import {
  getChildDeductions as getChildDeductionsRequest,
  getIncomeTypes,
} from 'modules/Taps/services/API';
import getTaxDeductionsTypes from 'modules/Taps/services/API/getTaxDeductionsTypes';
import getTaxpayerCategories from 'modules/Taps/services/API/getTaxpayerCategories';
import getFileCategories from 'modules/Taps/services/API/getFileCategories';

/**
 * @type {{GET_DEDUCTIONS_TAX_TYPES: DictionaryGeneratorContainer, GET_PROPERTY_RIGHTS: DictionaryGeneratorContainer, GET_CHILD_DEDUCTIONS: DictionaryGeneratorContainer, GET_FILES_CATEGORIES: DictionaryGeneratorContainer, GET_OBJECT_NAME_CODES: DictionaryGeneratorContainer, GET_ACION_TYPES_FOR_LAWYERS_INCOME: DictionaryGeneratorContainer, GET_TAX_PAYER_CATEGORIES: DictionaryGeneratorContainer, GET_INCOME_TAX_TYPES: DictionaryGeneratorContainer, GET_TAX_DEDUCTION_OWNER_CODES: DictionaryGeneratorContainer}}
 */
export const BASE_ACTIONS = {
  GET_TAX_DEDUCTION_OWNER_CODES: new DictionaryGeneratorContainer(
    'GET_TAX_DEDUCTION_OWNER_CODES',
    'taxDeductionOwnerCodes',
    getTaxDeductionOwnerCodes,
  ),
  GET_OBJECT_NAME_CODES: new DictionaryGeneratorContainer(
    'GET_OBJECT_NAME_CODES',
    'objectNameCodes',
    getObjectNameCodes,
  ),
  GET_PROPERTY_RIGHTS: new DictionaryGeneratorContainer(
    'GET_PROPERTY_RIGHTS',
    'propertyRights',
    getPropertyRightsNDFL3,
  ),
  GET_ACION_TYPES_FOR_LAWYERS_INCOME: new DictionaryGeneratorContainer(
    'GET_ACION_TYPES_FOR_LAWYERS_INCOME',
    'actionTypes',
    getActionTypesForLawyers,
  ),
  GET_INCOME_TAX_TYPES: new DictionaryGeneratorContainer(
    'GET_INCOME_TAX_TYPES',
    'incomeTypes',
    getIncomeTypes,
  ),
  GET_CHILD_DEDUCTIONS: new DictionaryGeneratorContainer(
    'GET_CHILD_DEDUCTIONS',
    'childdeductions',
    getChildDeductionsRequest,
  ),
  GET_DEDUCTIONS_TAX_TYPES: new DictionaryGeneratorContainer(
    'GET_DEDUCTIONS_TAX_TYPES',
    'deductionTypes',
    getTaxDeductionsTypes,
  ),
  GET_TAX_PAYER_CATEGORIES: new DictionaryGeneratorContainer(
    'GET_TAX_PAYER_CATEGORIES',
    'taxPayerCategories',
    getTaxpayerCategories,
  ),
  GET_FILES_CATEGORIES: new DictionaryGeneratorContainer(
    'GET_FILES_CATEGORIES',
    'fileCategories',
    getFileCategories,
  ),
};
/**
 * custom actions without states
 * @type {{SAVE_AND_GO_NEXT: string}}
 */
export const SAGA_ACTIONS = {
  GET_MONTH_INCOMES_LOADING: 'GET_MONTH_INCOMES_LOADING',
  GET_STD_DEDUCTIONS_SUCCESS: 'GET_STD_DEDUCTIONS_SUCCESS',
  GET_SOC_DEDUCTIONS_SUCCESS: 'GET_SOC_DEDUCTIONS_SUCCESS',
  CALCULATE_DEDUCTION: 'CALCULATE_DEDUCTION',
  CALCULATE_SUMS_SECTION: 'CALCULATE_SUMS_SECTION',
  GO_TO_STEP: 'GO_TO_STEP',
  GET_STD_BY_2NDFL: 'GET_STD_BY_2NDFL',
  GET_SOC_BY_2NDFL: 'GET_SOC_BY_2NDFL',
  GET_MONTH_INCOMES_RESULT: 'GET_MONTH_INCOMES_RESULT',
  GET_MONTH_INCOMES: 'GET_MONTH_INCOMES',
  SAVE_AND_EXIT: 'SAVE_AND_EXIT',
  SAVE_AND_GO_NEXT: 'SAVE_AND_GO_NEXT',
  SAVE_NDFL3_DRAFT_ATTACHES: 'SAVE_NDFL3_DRAFT_ATTACHES',
  SAVE_NDFL3_DRAFT_ATTACHES_SUCCESS: 'SAVE_NDFL3_DRAFT_ATTACHES_SUCCESS',
  SAVE_NDFL3_DRAFT_ATTACHES_ERROR: 'SAVE_NDFL3_DRAFT_ATTACHES_ERROR',
  LOAD_DATA_FOR_3NDFL_REQUEST_START: 'LOAD_DATA_FOR_3NDFL_REQUEST_START',
  FROM_RF_INCOME_SUM_CHANGED: 'FROM_RF_INCOME_SUM_CHANGED',
  SET_NDFL3_SUBMIT_FAIL: 'setNdfl3SubmitFailAction',
  INIT_NDFL3_PAGE: 'INIT_NDFL3_PAGE',
  GO_PREV_STEP: 'GO_PREV_STEP',
  LOADING_FINISH: 'LOADING_FINISH',
  LOADING_START: 'LOADING_START',
  LOADING_NDFL2_FINISH: 'LOADING_NDFL2_FINISH',
  LOADING_NDFL2_START: 'LOADING_NDFL2_START',
  UPDATE_INCOME_RATES: 'UPDATE_INCOME_RATES',
  UPDATE_INCOME_RATES_ERROR: 'UPDATE_INCOME_RATES_ERROR',
  UPDATE_TAX_PAYMENT_RATES: 'UPDATE_TAX_PAYMENT_RATES',
  UPDATE_TAX_PAYMENT_RATES_ERROR: 'UPDATE_TAX_PAYMENT_RATES_ERROR',
  CLEAR_RATE_ERRORS: 'CLEAR_RATE_ERRORS',
  GET_INCOME_BY_NDFL2_ID: 'GET_INCOME_BY_NDFL2_ID',
  UPDATE_ALL_DEPENDENT_GAME_DEDUCTION_FIELDS: 'UPDATE_ALL_DEPENDENT_GAME_DEDUCTION_FIELDS',
  UPDATE_RECEIPTS_LIST: 'UPDATE_RECEIPTS_LIST',
  UPDATE_CALCULATED_DEDUCTIONS_BY_INCOME_TYPE_CODE:
    'UPDATE_CALCULATED_DEDUCTIONS_BY_INCOME_TYPE_CODE',
  INITIALIZE_OVERPAYMENTS_DISPOSAL: 'INITIALIZE_OVERPAYMENTS_DISPOSAL',
  INITIALIZE_OVERPAYMENTS_DISPOSAL_SUCCESS: 'INITIALIZE_OVERPAYMENTS_DISPOSAL_SUCCESS',
  INITIALIZE_OVERPAYMENTS_DISPOSAL_FAILURE: 'INITIALIZE_OVERPAYMENTS_DISPOSAL_FAILURE',
};
